export function getPlatform() {
  if (!("navigator" in window)) {
    return "macos";
  }

  const os = (
    navigator.userAgentData?.platform || navigator.platform
  )?.toLowerCase();

  if (os.startsWith("win")) return "windows";
  if (os.startsWith("mac")) return "macos";
  if (os.startsWith("linux")) return "linux";

  return "macos";
}
